export const OPERATOR_FEEDBACK_LOCALSTORAGE_KEY = "new-workplace-operator-feedback"
const MONTH_MS = 1000 * 60 * 60 * 24 * 30

export function getOperatorFeedbackStatus(): boolean {
    const storedData = localStorage.getItem(OPERATOR_FEEDBACK_LOCALSTORAGE_KEY)

    if (!storedData) {
        return true
    }

    const lastDate = new Date(storedData)
    const now = new Date()

    if (now.getTime() - lastDate.getTime() > MONTH_MS) {
        localStorage.removeItem(OPERATOR_FEEDBACK_LOCALSTORAGE_KEY)
        return false
    }

    return false
}

export function saveOperatorFeedbackStatus() {
    localStorage.setItem(OPERATOR_FEEDBACK_LOCALSTORAGE_KEY, new Date().toISOString())
}
